/**
 * This file is auto-generated from ChatProfileData.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const title: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Personal data';
        case 'pl':
            return 'Dane osobowe';
    }
};
